import { render, staticRenderFns } from "./SearchNavItemSelect.vue?vue&type=template&id=0dd0374c&scoped=true"
import script from "./SearchNavItemSelect.vue?vue&type=script&lang=js"
export * from "./SearchNavItemSelect.vue?vue&type=script&lang=js"
import style0 from "./SearchNavItemSelect.vue?vue&type=style&index=0&id=0dd0374c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dd0374c",
  null
  
)

export default component.exports